import React from 'react';

const Description = () => (
    <div style={{textAlign: "justify"}}>
        I'm junior web-developer, which like learning new stuff about programming.
        I've 3 years of experience in Unreal Engine 4 and 1 year of experience in front-end development.
        Want to learn how to build more reliable and secure applications in right way. Want to feel how
        to be a teammate.
    </div>
);

export default Description;
